import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";

export const account = (props) => {
  return <AccountCircleRoundedIcon {...props} />;
};
